import { render, staticRenderFns } from "./editShoppersTask.vue?vue&type=template&id=007a73a0&scoped=true&"
import script from "./editShoppersTask.vue?vue&type=script&lang=js&"
export * from "./editShoppersTask.vue?vue&type=script&lang=js&"
import style0 from "./editShoppersTask.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./editShoppersTask.vue?vue&type=style&index=1&id=007a73a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007a73a0",
  null
  
)

component.options.__file = "editShoppersTask.vue"
export default component.exports